import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { BookDetailsResponse } from '../../responses/platform/book-details.response';
import { BookDetailsRequest } from '../../requests/platform/book-details.request';

@Injectable({
  providedIn: 'root'
})
export class BookDetailsService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public post(request: BookDetailsRequest): Observable<BookDetailsResponse> {
    return this.http
      .post<BookDetailsResponse>(
        environment.urlApiPlatform + "BookDetails", request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
